import React, { useState, useEffect } from 'react';
import { Toast, ToastOptions } from './Toast';

interface ToastContainerProps {
  toastData: { text: string; options: ToastOptions };
}
export const ToastContainer: React.FC<ToastContainerProps> = ({ toastData }) => {
  const [toast, setToast] = useState<any>(null);
  useEffect(() => {
    if (toastData) {
      setToast(
        <Toast
          text={toastData.text}
          options={toastData.options}
          onHide={() =>
            setTimeout(() => {
              setToast(null);
            }, 500)
          }
        />
      );
    }
  }, [toastData]);

  if (toast) return toast;
  else return <></>;
};
